import { render, staticRenderFns } from "./chess.vue?vue&type=template&id=58a9b1f6&scoped=true&"
import script from "./chess.vue?vue&type=script&lang=js&"
export * from "./chess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a9b1f6",
  null
  
)

export default component.exports